/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, November 12th 2021, 1:19:14 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */
import {
  ProcessTemplateArtifact,
  ProcessTemplateArtifactValidationSchema,
  ProcessTemplateArtifactSchemaType,
} from "lib/schemas";
import { WritableModel, WriteOnlyModel } from "lib/schemas/abstract";
import { schemaBuilder } from "lib/validation";

export interface ChoiceOptionGroup extends ProcessTemplateArtifact, WritableModel<false> {
  name: string;
  identifier: string;
  is_global?: boolean;
  form?: number;
}

export const ChoiceOptionGroupValidationSchema: ProcessTemplateArtifactSchemaType<WriteOnlyModel<ChoiceOptionGroup>> =
  ProcessTemplateArtifactValidationSchema.shape({
    name: schemaBuilder.string().required("Kindly provide the name for the option group."),
    identifier: schemaBuilder.string().required("Kindly provide the identifier for the option group."),
    is_global: schemaBuilder.boolean().default(false),
    form: schemaBuilder.number().optional(),
  });
